<template>
  <div class="surrender-dialog">
    <el-dialog
      title="员工保退保"
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose">
      <div v-loading="loading">
        <el-alert
          title="退保操作不可逆，请谨慎操作！"
          type="warning"
          show-icon
          :closable="false">
        </el-alert>


        <!-- 员工信息列表 -->
        <el-card class="employee-list-card" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span>员工信息</span>
          </div>
          
          <el-table 
            :data="employeeList" 
            border 
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="index" label="序号" width="60" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="120" align="center"></el-table-column>
            <el-table-column prop="idcard" label="身份证号" width="180" align="center"></el-table-column>
            <el-table-column prop="type" label="工作类型" width="200" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">搬运工人</span>
                <span v-else-if="scope.row.type === 4">司机押运</span>
                <span v-else-if="scope.row.type === 2">文员内勤</span>
                <span v-else>未知类型</span>
              </template>
            </el-table-column>
            <el-table-column label="退保保费(元)" width="150" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.amount"
                  placeholder="请输入退保保费"
                  @blur="calculateTotalAmount"
                  size="small">
                </el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <!-- 退保设置 -->
        <el-card class="surrender-settings-card" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span>退保设置</span>
          </div>
          
          <el-form :model="formData" ref="surrenderForm" label-width="150px" :rules="rules">
            <el-row>
              <el-col :span="12">
                <el-form-item label="退保批单生效时间：" prop="surrender_date">
                  <el-date-picker
                    v-model="formData.surrender_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择退保生效时间"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="应退总保费(元)：">
                  <el-input
                    v-model="totalAmount"
                    placeholder="总退保保费"
                    disabled
                    style="width: 100%;">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>

          <!-- 计算应退保费按钮 -->
          <div style="text-align: center; margin: 20px 0;">
            <el-button type="primary" @click="calculateRefundAmount" :loading="calculating">
              计算应退保费
            </el-button>
          </div>

          <!-- 应退保费明细 -->
          <el-table 
            :data="refundDetails" 
            border 
            style="width: 400px; margin: 20px auto;"
            v-if="refundDetails.length > 0">
            <el-table-column prop="workType" label="工作类型" width="150" align="center"></el-table-column>
            <el-table-column prop="refundAmount" label="应退保费(元)" width="150" align="center">
              <template slot-scope="scope">
                {{ formatMoney(scope.row.refundAmount) }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定退保</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { ygbOrderInfo, ygbCalculateRefundPremium, ygbReturnInsurance } from '@/api/member'

export default {
  name: 'Surrender',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitLoading: false,
      calculating: false,
      employeeList: [],
      selectedEmployees: [],
      formData: {
        surrender_date: ''
      },
      totalAmount: '0.00',
      refundDetails: [],
      rules: {
        surrender_date: [
          { required: true, message: '请选择退保生效时间', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    formatDate,
    formatMoney,
    


    // 初始化数据
    async initData() {
      if (!this.rowData || !this.rowData.id) {
        this.$message.error('订单信息不完整')
        return
      }

      this.loading = true
      try {
        // 获取订单详情和员工列表
        const response = await ygbOrderInfo({
          id: this.rowData.id,
          platform_type: 8
        })

        if (response && response.err_code === 0) {
          // 初始化员工列表 - 只显示状态为1的员工
          if (response.order && response.order.employee_list) {
            this.employeeList = response.order.employee_list
              .filter(emp => emp.status === 1)
              .map(emp => ({
                id: emp.id,
                name: emp.name || '',
                idcard: emp.idcard || emp.id_card || '',
                type: emp.type || 1,
                amount: '', // 退保保费，用户手动输入
                originalAmount: emp.amount || 0 // 原始保费
              }))
          }
        } else {
          this.$message.error(response?.err_msg || '获取订单信息失败')
        }
      } catch (error) {
        console.error('获取订单信息失败:', error)
        this.$message.error('获取订单信息失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 处理员工选择变化
    handleSelectionChange(selection) {
      this.selectedEmployees = selection
      this.calculateTotalAmount()
    },

    // 计算总退保保费
    calculateTotalAmount() {
      let total = 0
      this.selectedEmployees.forEach(emp => {
        if (emp.amount && !isNaN(emp.amount)) {
          total += parseFloat(emp.amount)
        }
      })
      this.totalAmount = total.toFixed(2)
    },

    // 计算应退保费（调用API）
    async calculateRefundAmount() {
      if (!this.formData.surrender_date) {
        this.$message.warning('请先选择退保生效时间')
        return
      }

      if (this.selectedEmployees.length === 0) {
        this.$message.warning('请先选择要退保的员工')
        return
      }



      this.calculating = true
      try {
        // 调用保费计算API
        const response = await ygbCalculateRefundPremium({
          effect_date: this.formData.surrender_date,
          order_id: parseInt(this.rowData.id)
        })

        if (response && response.err_code === 0) {
          const data = response.data
          // 按照老系统的逻辑处理价格数据
          const cPrice = data.cPrice / 10000 // 文员内勤价格
          const dPrice = data.dPrice / 10000 // 搬运工人价格  
          const tPrice = data.tPrice / 10000 // 司机押运价格

          // 为选中的员工设置对应的退保保费
          this.selectedEmployees.forEach(emp => {
            if (emp.type === 1) {
              emp.amount = dPrice.toFixed(2) // 搬运工人
            } else if (emp.type === 2) {
              emp.amount = cPrice.toFixed(2) // 文员内勤
            } else if (emp.type === 4) {
              emp.amount = tPrice.toFixed(2) // 司机押运
            }
          })

          // 更新退保明细
          const typeAmounts = { 1: 0, 2: 0, 4: 0 }
          const typeNames = { 1: '搬运工人', 2: '文员内勤', 4: '司机押运' }
          const typePrices = { 1: dPrice, 2: cPrice, 4: tPrice }

          this.selectedEmployees.forEach(emp => {
            typeAmounts[emp.type] += typePrices[emp.type]
          })

          this.refundDetails = Object.keys(typeAmounts)
            .filter(type => typeAmounts[type] > 0)
            .map(type => ({
              workType: typeNames[type],
              refundAmount: Math.round(typeAmounts[type] * 100) // 转换为分，供formatMoney使用
            }))

          // 重新计算总金额
          this.calculateTotalAmount()
          this.$message.success('应退保费计算完成')
        } else {
          this.$message.error(response?.err_msg || '计算应退保费失败')
        }
      } catch (error) {
        console.error('计算应退保费失败:', error)
        this.$message.error('计算应退保费失败，请稍后重试')
      } finally {
        this.calculating = false
      }
    },



    // 提交退保申请
    handleSubmit() {
      if (this.selectedEmployees.length === 0) {
        this.$message.warning('请选择要退保的员工')
        return
      }

      // 验证所有选中员工都有退保保费
      const invalidEmployees = this.selectedEmployees.filter(emp => !emp.amount || isNaN(emp.amount) || parseFloat(emp.amount) <= 0)
      if (invalidEmployees.length > 0) {
        this.$message.warning('请为所有选中的员工输入有效的退保保费')
        return
      }

      this.$refs.surrenderForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          
          // 准备退保数据 - 按照老系统的格式
          const employeeList = this.selectedEmployees.map(emp => ({
            id: emp.id,
            amount: Math.round(parseFloat(emp.amount) * 100) * 100 // 转换为分
          }))

          const surrenderData = {
            order_id: parseInt(this.rowData.id),
            all_amount: Math.round(parseFloat(this.totalAmount) * 100), // 转换为分
            employee_list: employeeList,
            expire_date: this.formData.surrender_date
          }

          // 调用退保接口 - 使用老系统的接口路径
          this.callSurrenderAPI(surrenderData)
        }
      })
    },

    // 调用退保API
    async callSurrenderAPI(data) {
      try {
        // 调用退保接口
        const response = await ygbReturnInsurance(data)

        if (response && response.err_code === 0) {
          this.$message.success('退保申请提交成功')
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error(response?.err_msg || '退保申请提交失败')
        }
      } catch (error) {
        console.error('退保接口调用失败:', error)
        this.$message.error('退保申请提交失败，请稍后重试')
      } finally {
        this.submitLoading = false
      }
    },

    // 关闭对话框
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.resetForm()
    },

    // 重置表单
    resetForm() {
      this.employeeList = []
      this.selectedEmployees = []
      this.formData = {
        surrender_date: ''
      }
      this.totalAmount = '0.00'
      this.refundDetails = []
      if (this.$refs.surrenderForm) {
        this.$refs.surrenderForm.resetFields()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.surrender-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  
  .employee-list-card,
  .surrender-settings-card {
    margin-bottom: 20px;
    
    /deep/ .el-card__header {
      background-color: #f5f7fa;
      font-weight: bold;
    }
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .el-table {
    margin-top: 10px;
  }
  
  /deep/ .el-table th {
    background-color: #f5f7fa;
  }
}
</style>